export default {
  layout: {
    title: 'Become Better Equipped To Grow Your Business On Amazon',
    hint: 'Dominate your competition, increase sales & drive business growth using a combination of Eva’s Amazon management services, market expertise and powerful optimization software.',
    balloons: {
      balloon_1: {
        label: 'Ad Spend Optimized',
        value: '$1.6B+',
      },
      balloon_2: {
        label: 'Sales Generated',
        value: '$6B+',
      },
      balloon_3: {
        label: 'Avg. Increase in Profitability',
        value: '51%',
      },
    },
  },
  login: {
    title: 'Welcome back',
    hint: 'Please login to your account',
    remember_me: 'Remember My Password',
    forgot_password: 'Forgot Your Password?',
    login: 'Login',
    logging_in: 'Logging in',
    no_account: "Don't have an account?",
    create_account: 'Create your Eva account.',
    create_account_promo: 'Instantly experience success on Amazon.',
  },
  forgot_password: {
    title: 'Recover Your Password',
    hint: `Please enter your email address and we'll send you instructions on
        how to reset your password.`,
    recover_password: 'Recover Password',
    back_to_login: 'Back to Login',
    start_eva: 'Start Eva Free now.',
    messages: {
      200: 'We sent an email with password reset link. Please check your mailbox and click the link to reset password.',
      401: 'Email is not verified. Please check your mailbox to verify.',
      404: 'Email is not registered.',
    },
  },
  reset_password: {
    title: 'Reset Password',
    hint: 'Please enter your new password.',
  },
};
